import { KeyPair } from './base';

export class CompanyDeductionConfig {
  Id: string;
  Type: number;
  Name: string;
  IsActive: boolean;
  IsLoan: boolean;
  CanHaveRates: boolean;
  CanHaveDisposableLimits: boolean;
  CanHaveAnnualLimit: boolean;
  DisbursementAtEmployee: boolean;
  ShowDisbursementControls: boolean;
  EmploymentTypeId: number;
  ThirdPartyPayees: KeyPair[];
  // bug 5414. use this value to default deduction.SelectedThirdPartyPayee when adding new deduction
  ThirdPartyPayee: number;
  IsPercentageDeduction: boolean;
  RequiresDisposableLimit: boolean;
  MasterCode: string;
  IntegrityHash: string;
  CalculationMethod: number;
  AppearanceSequence: number;
  DisplayInGrid: boolean;
}

export enum DeductionCalculations {
  'Fixed' = 0,
  'Rate' = 1,
  'Simple Matching' = 2,
  'Percent of Earning' = 3,
  'Percent of Deduction' = 4,
  'Percent of Gross' = 5,
  'Percent of Net' = 6,
  'Tiered Matching' = 7
}
